import React from 'react';
export var Loading = function () { return (React.createElement("div", { className: "Loading" },
    React.createElement("div", { className: "Loading__spinner" },
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)))); };
